import { render, staticRenderFns } from "./AnalyGameInfo.vue?vue&type=template&id=0563f996&"
import script from "./AnalyGameInfo.vue?vue&type=script&lang=js&"
export * from "./AnalyGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./AnalyGameInfo.vue?vue&type=style&index=0&id=0563f996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports